import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { archiveVehiclesFailed, archiveVehiclesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* archiveVehicles(action) {
  try {
    if (!action.payload) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/registries/vehicles/${action.payload}/archive`;
    const response = yield makeRequest(url, {}, action, 'POST', true);
    if (response.status === NO_CONTENT) {
      yield put(archiveVehiclesSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(archiveVehiclesFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(archiveVehiclesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
